// src/components/Header.jsx
import React, { useState } from 'react';
import '../css/Header.css';
import logo from '../assets/logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="header">
      <div className="container">
        <img src={logo} alt="Company Logo" className="logo" />
        
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>

        <nav className={`nav ${isOpen ? 'open' : ''}`}>
          <a href="#about" onClick={() => setIsOpen(false)}>About Us</a>
          <a href="#services" onClick={() => setIsOpen(false)}>Services</a>
          <a href="#cases" onClick={() => setIsOpen(false)}>Successful Cases</a>
          <a href="#contact" onClick={() => setIsOpen(false)}>Contact</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
